<template>
    <div class="component-settings-stores">
        <div class="el-card__header text-left border" style="margin-left: 225px;" slot="header" v-if="$store.state.general.settingsMenuMode === 'vertical'">
            <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
        </div>
        <div class="el-card__header text-left border" slot="header" v-else>
            <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
        </div>
        <el-card class="box-card" id="main-header" shadow="never"
                 style="border: none; border-radius: 0px; min-height: 400px; background-color: #f4f7fa;"
                 body-style="background-color: #f4f7fa; padding: 20px 0px;"
        >
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card text-left" shadow="never" v-loading="!loaded">
                        <el-alert
                            :title="getMessage('update')"
                            type="success"
                            show-icon
                            v-if="$route.params.update === true">
                        </el-alert>
                        <el-alert
                            :title="getMessage('add')"
                            type="success"
                            show-icon
                            v-if="$route.params.add === true">
                        </el-alert>
                        <el-alert
                            :title="getMessage('delete')"
                            type="success"
                            show-icon
                            v-if="$route.params.delete === true">
                        </el-alert>
                        <el-tabs v-model="activeName">
                            <el-tab-pane label="Stores" name="Stores">
                                <div class="row">
                                    <div class="col-12">
                                        <el-input
                                            v-model="search"
                                            placeholder="Type to search"
                                            style="width: 200px; float: left; margin-right: 5px;"
                                        />
                                        <el-button class="fr" type="primary" plain @click="$router.push({'name': 'settings-store-add'})">Add store</el-button>
                                    </div>
                                </div>
                                <template>
                                    <el-table
                                        :data="tableData.filter(data => !search || String(data['store_name']).toLowerCase().includes(search.toLowerCase()))"
                                        style="width: 100%; margin: 20px 0px;"
                                        :default-sort = "{prop: 'store_id', order: 'ascending'}">
                                        >
                                        <el-table-column sortable prop="store_id" label="Store">
                                            <template slot-scope="scope">
                                                <span v-if="$store.state.general.allStores.find(x => parseInt(x.store_id) === parseInt(scope.row.store_id)) !== undefined">{{$store.state.general.allStores.find(x => parseInt(x.store_id) === parseInt(scope.row.store_id))['store_name']}}</span>
                                                <span v-else>No store name</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            v-for="col in columns"
                                            :key="col.key"
                                            :prop="col.prop"
                                            :label="col.label"
                                            sortable>
                                        </el-table-column>
                                        <el-table-column
                                            key="action"
                                            prop="action"
                                            label=""
                                            v-if="editable"
                                        >
                                            <template slot-scope="scope">
                                                <div>
                                                    <el-button
                                                        size="small"
                                                        type="primary"
                                                        plain
                                                        @click="rowClicked(scope.row)"
                                                    >Edit</el-button>
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </el-tab-pane>
                            <el-tab-pane label="Missing" name="Missing">
                                <div class="row">
                                    <div class="col-12">
                                        <el-input
                                            v-model="searchMissing"
                                            placeholder="Type to search"
                                            style="width: 200px; float: left; margin-right: 5px;"
                                        />
                                    </div>
                                </div>
                                <template>
                                    <el-table
                                        :data="tableDataMissing.filter(data => !searchMissing || String(data['store_id']).includes(searchMissing))"
                                        style="width: 100%; margin: 20px 0px;">
                                        <el-table-column sortable prop="store_id" label="Store">
                                            <template slot-scope="scope">
                                                <span v-if="$store.state.general.allStores.find(x => parseInt(x.store_id) === parseInt(scope.row.store_id)) !== undefined">{{$store.state.general.allStores.find(x => parseInt(x.store_id) === parseInt(scope.row.store_id))['store_name']}}</span>
                                                <span v-else>{{scope.row.store_id}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            v-for="col in columnsMissing"
                                            :key="col.key"
                                            :prop="col.prop"
                                            :label="col.label"
                                        >
                                            <template slot-scope="scope">
                                                <el-checkbox :value="scope.row[col.prop] !== null && scope.row[col.prop] !== 'null'"></el-checkbox>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            key="action"
                                            prop="action"
                                            label=""
                                            v-if="editable"
                                        >
                                            <template slot-scope="scope">
                                                <div v-if="scope.row['store_exists'] === true">
                                                    <el-button
                                                        size="small"
                                                        type="primary"
                                                        plain
                                                        @click="rowClicked(scope.row)"
                                                    >Edit</el-button>
                                                </div>
                                                <div v-if="scope.row['store_exists'] === false">
                                                    <el-button
                                                        size="small"
                                                        type="success"
                                                        plain
                                                        @click="rowClicked(scope.row)"
                                                    >Add</el-button>
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </el-tab-pane>
                        </el-tabs>
                    </el-card>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
import axios from '@/services/axios.js'
import { getTableHeaders, getHeadersWithAccessToken } from '../../functions.js'
export default {
    data () {
        return {
            users: {},
            activeName: 'Stores',
            tableData: [],
            tableDataMissing: [],
            columns: [],
            columnsMissing: [],
            search: '',
            searchMissing: '',
            editable: false,
            loaded: false
        }
    },
    components: {

    },
    methods: {
        rowClicked (row) {
            if (row['store_exists'] === false) {
                this.$router.push({ 'name': 'settings-store-add', query: { 'store_id': row['store_id'] } })
            } else {
                this.$router.push({ 'name': 'settings-store-detail', query: { 'store_id': row['store_id'] } })
            }
        },
        getMessage (type) {
            if (type === 'update') {
                return 'Store ' + this.$route.params.store_id + ' successfully updated'
            } else if (type === 'delete') {
                return 'Store ' + this.$route.params.store_id + ' deleted'
            } else {
                return 'Store ' + this.$route.params.store_id + ' added'
            }
        }
    },
    created () {
        this.$store.dispatch('general/getAllStores').then(response => {
            this.loaded = true
        })
            .catch(error => {
                console.log(error)
            })
        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/stores', { 'headers': getHeadersWithAccessToken() })
            .then(response => {
                this.editable = response.data.editable
                this.tableData = response.data.data
                // Need to convert boolean field since Element-ui/vue cannot deal with boolean fields in plain html/a table
                for (let i in this.tableData) {
                    for (let key of Object.keys(this.tableData[i])) {
                        if (typeof this.tableData[i][key] === 'boolean') {
                            this.tableData[i][key] = String(this.tableData[i][key])
                        }
                    }
                }
                this.columns = getTableHeaders(Object.keys(response.data.data[0]))
                let item = this.columns.find(x => x.prop === 'store_id')
                let idx = this.columns.indexOf(item)
                this.columns.splice(idx, 1)
                item = this.columns.find(x => x.prop === 'store_name')
                idx = this.columns.indexOf(item)
                this.columns.splice(idx, 1)
            })
            .catch(error => {
                console.log(error)
            })
        axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/settings/stores/data_missing', { 'format': 'aod' }, { 'headers': getHeadersWithAccessToken() })
            .then(response => {
                this.tableDataMissing = response.data.data
                // We need to remove store_id as this is hardcoded
                let cols = response.data.columns
                let idx = cols.indexOf('store_id')
                cols.splice(idx, 1)
                idx = cols.indexOf('store_exists')
                cols.splice(idx, 1)
                this.columnsMissing = getTableHeaders(cols)
            })
            .catch(error => {
                console.log(error)
            })
    }
}
</script>

<style lang="scss">
.component-settings-stores {
    p {
        margin-bottom: 0px;
    }
    .el-card__body {
        padding-bottom: 0px !important;
    }
    .el-checkbox__inner {
        height: 21px !important;
        width: 21px !important;
    }
    .el-checkbox__inner::after {
        height: 10.5px;
        left: 7px;
        width: 4.5px;
    }
}
</style>
